import cx from 'clsx';
import { eachMonthOfInterval, eachYearOfInterval, format, getMonth, getYear } from 'date-fns';
import React from 'react';
import type { ReactDatePickerCustomHeaderProps } from 'react-datepicker';

import { ReactComponent as ArrowIcon } from '@assets/svg/arrowLeft.svg';

import style from '../style.module.scss';
import DatepickerHeaderDropdown from './DatepickerHeaderDropdown';

interface IProps extends ReactDatePickerCustomHeaderProps {
  changeYear: (year: number) => void;
  showMonthDropdown?: boolean;
  showYearDropdown?: boolean;
  minDate?: Date;
  maxDate?: Date;
}

const DatepickerHeader = ({
  date,
  changeYear,
  changeMonth,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  showMonthDropdown,
  showYearDropdown,
  minDate,
  maxDate,
}: IProps) => {
  const currentYear = new Date().getFullYear();

  const months = eachMonthOfInterval({
    start: new Date(currentYear, 0),
    end: new Date(currentYear, 11),
  });

  const years = eachYearOfInterval({
    start: minDate ? new Date(minDate.getFullYear(), 0) : new Date(currentYear - 20, 0),
    end: maxDate ? new Date(maxDate.getFullYear(), 11) : new Date(currentYear + 20, 11),
  });

  return (
    <div className={style.datePickerHeader}>
      <div
        className={cx(style.prevMonthButton, { [style.buttonDisabled]: prevMonthButtonDisabled })}
        onClick={decreaseMonth}
      >
        <ArrowIcon />
      </div>

      <div className={style.dropdownsContainer}>
        {showMonthDropdown && (
          <DatepickerHeaderDropdown
            currentValue={getMonth(date).toString()}
            onChange={changeMonth}
            values={months.map((date) => format(date, 'MMMM'))}
            type="months"
          />
        )}

        {showYearDropdown && (
          <DatepickerHeaderDropdown
            currentValue={getYear(date).toString()}
            onChange={changeYear}
            values={years.map((date) => getYear(date).toString())}
            type="years"
          />
        )}
      </div>

      <div
        className={cx(style.nextMonthButton, { [style.buttonDisabled]: nextMonthButtonDisabled })}
        onClick={increaseMonth}
      >
        <ArrowIcon />
      </div>
    </div>
  );
};

export default DatepickerHeader;
